import { B200, G400, G500, N0, N20, N200, N400, N70 } from '@atlaskit/theme/colors';
var colorMap = {
  backgroundColorChecked: "var(--ds-background-success-bold, ".concat(G400, ")"),
  backgroundColorCheckedHover: "var(--ds-background-success-bold-hovered, ".concat(G500, ")"),
  backgroundColorCheckedDisabled: "var(--ds-background-disabled, ".concat(N20, ")"),
  backgroundColorUnchecked: "var(--ds-background-neutral-bold, ".concat(N200, ")"),
  backgroundColorUncheckedHover: "var(--ds-background-neutral-bold-hovered, ".concat(N400, ")"),
  backgroundColorUncheckedDisabled: "var(--ds-background-disabled, ".concat(N20, ")"),
  borderColorFocus: "var(--ds-border-focused, ".concat(B200, ")"),
  iconColorChecked: "var(--ds-icon-inverse, ".concat(N0, ")"),
  iconColorDisabled: "var(--ds-icon-disabled, ".concat(N70, ")"),
  iconColorUnchecked: "var(--ds-icon-inverse, ".concat(N0, ")"),
  handleBackgroundColor: "var(--ds-icon-inverse, ".concat(N0, ")"),
  handleBackgroundColorChecked: "var(--ds-icon-inverse, ".concat(N0, ")"),
  handleBackgroundColorDisabled: "var(--ds-icon-inverse, ".concat(N0, ")")
};
export var getColors = function getColors() {
  return colorMap;
};